import { cn } from '@/lib/cn';
import { ClipboardList, ClipboardPen, Droplets, GitBranch, History, ImageIcon, TrendingUp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export type AnimalDetailTabId =
  | 'ficha'
  | 'media'
  | 'timeline'
  | 'leite'
  | 'zootecnia'
  | 'afiliacao'
  | 'alteracoes';

export function AnimalDetailTabs({
  tab,
  onChange,
  showDairy = false,
  trailing,
}: {
  tab: AnimalDetailTabId;
  onChange: (tab: AnimalDetailTabId) => void;
  showDairy?: boolean;
  trailing?: ReactNode;
}) {
  const tabs: { id: AnimalDetailTabId; label: string; icon: LucideIcon }[] = [
    { id: 'ficha', label: 'Ficha do Animal', icon: ClipboardList },
    { id: 'media', label: 'Mídias', icon: ImageIcon },
    { id: 'timeline', label: 'Linha do Tempo', icon: History },
    ...(showDairy
      ? [{ id: 'leite' as const, label: 'Controle Leiteiro', icon: Droplets }]
      : []),
    { id: 'zootecnia', label: 'Zootecnia', icon: TrendingUp },
    { id: 'afiliacao', label: 'Afiliação', icon: GitBranch },
    { id: 'alteracoes', label: 'Alterações', icon: ClipboardPen },
  ];

  return (
    <div className="flex items-end justify-between gap-3 border-b border-manejai-sand/70">
      <div
        role="tablist"
        aria-label="Seções do animal"
        className="flex min-w-0 flex-wrap items-end gap-x-8 gap-y-2 sm:gap-x-12"
      >
      {tabs.map((item) => {
        const active = tab === item.id;
        const Icon = item.icon;

        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.id)}
            className={cn(
              '-mb-px inline-flex items-center gap-1.5 border-b-[3px] px-1 pb-3 pt-1 text-sm transition-colors',
              active
                ? 'border-manejai-forest font-semibold text-manejai-forest'
                : 'border-transparent font-medium text-manejai-bark/55 hover:border-manejai-sand hover:text-manejai-bark',
            )}
          >
            <Icon className="h-4 w-4 shrink-0" aria-hidden />
            {item.label}
          </button>
        );
      })}
      </div>
      {trailing ? <div className="mb-2 shrink-0">{trailing}</div> : null}
    </div>
  );
}
